var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        scrollbar: false,
        width: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.onOpen,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "padding-lr",
          attrs: { model: _vm.form, rules: _vm.formRules },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "taConfigName", label: "TA Name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Please input TA Name" },
                model: {
                  value: _vm.form.taConfigName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "taConfigName", $$v)
                  },
                  expression: "form.taConfigName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "status", label: "Status", required: "" } },
            [
              _c(
                "div",
                { staticStyle: { width: "100%", float: "left" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-color": "#d52b1e",
                      "inactive-color": "#f2f3f6",
                    },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.form.status ? "可用" : "不可用")),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.onSave },
            },
            [_vm._v(" Save ")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }